// Icons + Kurzbeschreibungen je Feldtyp für den Formular-Builder.
// Macht Palette und Feldkarten selbsterklärend.

import type { ComponentType, SVGProps } from "react";
import {
  Bars3BottomLeftIcon,
  CalculatorIcon,
  CalendarDaysIcon,
  CameraIcon,
  CheckCircleIcon,
  ChevronUpDownIcon,
  ClockIcon,
  CubeIcon,
  DocumentTextIcon,
  HashtagIcon,
  InformationCircleIcon,
  LinkIcon,
  ListBulletIcon,
  MapPinIcon,
  MinusIcon,
  PaperClipIcon,
  PencilSquareIcon,
  ScissorsIcon,
  Squares2X2Icon,
  SquaresPlusIcon,
} from "@heroicons/react/24/outline";

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

const FIELD_TYPE_ICONS: Record<string, IconComponent> = {
  text: Bars3BottomLeftIcon,
  number: HashtagIcon,
  date: CalendarDaysIcon,
  datetime: ClockIcon,
  checkbox: CheckCircleIcon,
  select: ChevronUpDownIcon,
  multiselect: ListBulletIcon,
  file: PaperClipIcon,
  photo: CameraIcon,
  "pdf-upload": DocumentTextIcon,
  geo: MapPinIcon,
  formula: CalculatorIcon,
  signature: PencilSquareIcon,
  article_ref: CubeIcon,
  article_ref_list: Squares2X2Icon,
  material_link: LinkIcon,
  linked_asset: LinkIcon,
  static_text: InformationCircleIcon,
  page_break: ScissorsIcon,
  divider: MinusIcon,
};

export function getFieldTypeIcon(type: string): IconComponent {
  return FIELD_TYPE_ICONS[type] || SquaresPlusIcon;
}

/** Kurze, laienverständliche Beschreibung je Feldtyp. */
export const FIELD_TYPE_HINTS: Record<string, string> = {
  text: "Freitext eingeben",
  number: "Zahlenwert eingeben",
  date: "Datum auswählen",
  datetime: "Datum und Uhrzeit auswählen",
  checkbox: "Ja/Nein abhaken",
  select: "Eine Option auswählen",
  multiselect: "Mehrere Optionen auswählen",
  file: "Beliebige Datei anhängen",
  photo: "Foto aufnehmen oder hochladen",
  "pdf-upload": "PDF-Dokument hochladen",
  geo: "GPS-Position erfassen",
  formula: "Automatisch berechneter Wert",
  signature: "Unterschrift erfassen",
  article_ref: "Einen Artikel verknüpfen",
  article_ref_list: "Mehrere Artikel verknüpfen",
  material_link: "Material aus Stammdaten bei Mangel übernehmen",
  linked_asset: "Wartungsobjekt verknüpfen",
  static_text: "Hinweistext im Formular anzeigen",
  page_break: "Neue Formularseite beginnen",
  divider: "Optische Trennlinie einfügen",
};

export function getFieldTypeHint(type: string): string {
  return FIELD_TYPE_HINTS[type] || "";
}

/** Gruppierung der Feldtypen für die Palette. */
export const FIELD_TYPE_GROUPS: { id: string; label: string; types: string[] }[] = [
  { id: "input", label: "Eingabe", types: ["text", "number", "date", "datetime", "checkbox"] },
  { id: "choice", label: "Auswahl", types: ["select", "multiselect"] },
  { id: "media", label: "Dateien & Medien", types: ["file", "photo", "pdf-upload", "signature"] },
  {
    id: "special",
    label: "Speziell",
    types: ["geo", "formula", "article_ref", "article_ref_list", "material_link", "linked_asset"],
  },
  { id: "layout", label: "Layout & Struktur", types: ["static_text", "page_break", "divider"] },
];
